import React from 'react';
import { Sparkles, Cloud } from '@react-three/drei';
import { getDevicePerformanceTier } from '../MobileOptimizer';

export default function DiscoveryNebula() {
  const tier = getDevicePerformanceTier();
  const showCloud = tier === 'high';

  return (
    <group position={[0, 0, -50]}>
      {showCloud && (
        <Cloud 
          opacity={0.3} 
          speed={0.1} 
          width={20} 
          depth={5} 
          segments={20} 
          color="#43DDD0" 
        />
      )}
      
      <Sparkles count={200} scale={[30, 15, 15]} size={4} speed={0.2} color="#43DDD0" opacity={0.3} />
      <Sparkles count={150} scale={[25, 12, 12]} size={3} speed={0.3} color="#ffffff" opacity={0.4} />
      <Sparkles count={100} scale={[20, 10, 10]} size={5} speed={0.1} color="#7c3aed" opacity={0.2} />
    </group>
  );
}
